import PropTypes from 'prop-types';
import React from 'react';
import Bouncer from './Bouncer';
import { LoadingWrapper } from './styled';

function PageLoader({ loaded }) {
  return (
    <LoadingWrapper loaded={loaded}>
      <Bouncer />
    </LoadingWrapper>
  );
}

PageLoader.propTypes = {
  loaded: PropTypes.bool,
};

PageLoader.defaultProps = {
  loaded: false,
};

// always re-render (event no visual visiblity) => need memo
export default React.memo(PageLoader);
